module.exports = __webpack_public_path__ + "img/01.36deb8e1.png";